const GAP = 24;

function getItemsPerView() {
	const width = window.innerWidth;
	if (width < 782) return 1;
	if (width < 1150) return 2;
	return 3;
}

function initCarousel(block) {
	if (block.dataset.testimonialsInit === "true") {
		return;
	}

	const viewport = block.querySelector(".testimonials-viewport");
	const track = block.querySelector(".testimonials-track");
	const cards = track ? Array.from(track.querySelectorAll(".testimonials-card")) : [];
	const prevButton = block.querySelector(".testimonials-prev");
	const nextButton = block.querySelector(".testimonials-next");

	if (!viewport || !track || !cards.length) {
		return;
	}

	block.dataset.testimonialsInit = "true";
	let currentIndex = 0;

	function updateCarousel(smooth) {
		const perView = getItemsPerView();
		const maxIndex = Math.max(0, cards.length - perView);
		currentIndex = Math.min(Math.max(0, currentIndex), maxIndex);

		const cardWidth = cards[0].getBoundingClientRect().width;
		viewport.scrollTo({
			left: currentIndex * (cardWidth + GAP),
			behavior: smooth ? "smooth" : "auto",
		});

		if (prevButton) {
			prevButton.disabled = currentIndex === 0;
			prevButton.style.opacity = currentIndex === 0 ? "0.4" : "1";
		}

		if (nextButton) {
			nextButton.disabled = currentIndex >= maxIndex;
			nextButton.style.opacity = currentIndex >= maxIndex ? "0.4" : "1";
		}
	}

	if (prevButton) {
		prevButton.addEventListener("click", (event) => {
			event.preventDefault();
			currentIndex -= 1;
			updateCarousel(true);
		});
	}

	if (nextButton) {
		nextButton.addEventListener("click", (event) => {
			event.preventDefault();
			currentIndex += 1;
			updateCarousel(true);
		});
	}

	window.addEventListener("resize", () => updateCarousel(false));
	window.addEventListener("load", () => updateCarousel(false));
	updateCarousel(false);
}

function bootTestimonialsCarousels() {
	document
		.querySelectorAll("[data-testimonials-carousel]")
		.forEach((block) => initCarousel(block));
}

if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", bootTestimonialsCarousels);
} else {
	bootTestimonialsCarousels();
}
